<section id="dashboard-container">
  <!-- Sub Header -->
  <app-header title="Correspondences">
    <!--  Filter -->
    <mat-toolbar class="filter-toolbar">
      <!--<mat-toolbar-row>-->
      <div
        class="filter-toolbar-heading flex-row-start-center gap-1"
        (click)="openDialog()">
        <button mat-raised-button mat-icon-button>
          <mat-icon>filter_list</mat-icon>
        </button>
        <h2>Filter</h2>
      </div>
      <app-filter-viewer
        [filter]="filter"
        (updated)="refreshFilter($event)"></app-filter-viewer>
      <!--</mat-toolbar-row>-->
    </mat-toolbar>
  </app-header>
  <!-- Correspondences -->
  @if (noAccessDashboard) {
    <div>
      <h2>
        Sorry, you do not have access to the dashboard. Please consult an
        administrator of this system.
      </h2>
    </div>
  }
  @if (corrObs | async; as corrs) {
    <section class="container block-list">
      <ul role="list" class="container block-list dashboard-cor-list list-no-bullet list-no-indent">
        @for (corr of corrs; track corr; let i = $index) {
          <li role="listitem">
            <div
              role="link"
              [routerLink]="['/correspondence', corr.Id]"
              [class]="{ unopened: corr.Status === 'Unopened', 'dashboard-cor-listitem': true }"
            >
              <div class="corr-list-heading flex-row-between-center">
                <h2>{{ corr.DateReceived | date: 'MMM d' }}</h2>
                <div>
                  <mat-icon matListItemIcon>chevron_right</mat-icon>
                  <span class="element">
                    {{ corr.Status || 'Status unavailable' }}
                  </span>
                </div>
              </div>
              <mat-divider style="position: relative"></mat-divider>
              <div>
                <div class="flex-column">
                  <h3 matListItemTitle>{{ corr.RequestorName }}</h3>
                  <p matListItemLine>{{ corr.Title }}</p>
                  <p class="corr-list-summary" matListItemLine>
                    {{ corr.Summary?.substr(0, 105)
                    }}{{ corr.Summary?.length > 105 ? '...' : '' }}
                  </p>
                </div>
              </div>
            </div>
          </li>
        }
      </ul>
      <div class="list-paginator">
        <mat-paginator
          class="container"
          [length]="totalItems"
          [pageSize]="10"
          [pageSizeOptions]="[5, 10, 25, 100]"
          (page)="setPage($event)">
        </mat-paginator>
      </div>
    </section>
  }
</section>
